import { render, staticRenderFns } from "./SidUploadVideo.vue?vue&type=template&id=c1a69e5a"
import script from "./SidUploadVideo.vue?vue&type=script&lang=js"
export * from "./SidUploadVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports